module.exports = __webpack_public_path__ + "img/Schalk.4aeeb023.svg";